<template>
  <page-layout :title="title">
    <a-card :bordered="false">
      <detail-list :title="$t('退款申请')">
        <detail-list-item :term="$t('取货单号')">1000000000</detail-list-item>
        <detail-list-item :term="$t('状态')">已取货</detail-list-item>
        <detail-list-item :term="$t('销售单号')">1234123421</detail-list-item>
        <detail-list-item :term="$t('子订单')">3214321432</detail-list-item>
      </detail-list>
      <a-divider style="margin-bottom: 32px"/>
      <detail-list :title="$t('用户信息')">
        <detail-list-item :term="$t('用户姓名')">付小小</detail-list-item>
        <detail-list-item :term="$t('联系电话')">18100000000</detail-list-item>
        <detail-list-item :term="$t('常用快递')">菜鸟仓储</detail-list-item>
        <detail-list-item :term="$t('取货地址')">浙江省杭州市西湖区万塘路18号</detail-list-item>
        <detail-list-item :term="$t('备注')">	无</detail-list-item>
      </detail-list>
      <a-divider style="margin-bottom: 32px"/>

      <div class="title">{{ $t('退货商品') }}</div>
      <s-table
        style="margin-bottom: 24px" 
        :columns="goodsColumns" 
        :data="loadGoodsData">

      </s-table>

      <div class="title">{{ $t('退货进度') }}</div>
      <s-table
        style="margin-bottom: 24px"
        :columns="scheduleColumns"
        :data="loadScheduleData">

        <template
          slot="status"
          slot-scope="status">
          <a-badge :status="status" :text="statusText(status)"/>
        </template>

      </s-table>
    </a-card>
  </page-layout>
</template>

<script>
  import PageLayout from '@/components/page/PageLayout'
  import STable from '@/components/table/'
  import DetailList from '@/components/tools/DetailList'
  import ABadge from "ant-design-vue/es/badge/Badge"
  const DetailListItem = DetailList.Item

  export default {
    components: {
      PageLayout,
      ABadge,
      DetailList,
      DetailListItem,
      STable
    },
    data () {
      return {
        // 加载数据方法 必须为 Promise 对象
        loadGoodsData: () => {
          return new Promise((resolve => {
            resolve({
              data: [
                {
                  id: '1234561',
                  name: '矿泉水 550ml',
                  barcode: '12421432143214321',
                  price: '2.00',
                  num: '1',
                  amount: '2.00'
                },
                {
                  id: '1234562',
                  name: '凉茶 300ml',
                  barcode: '12421432143214322',
                  price: '3.00',
                  num: '2',
                  amount: '6.00'
                },
                {
                  id: '1234563',
                  name: '好吃的薯片',
                  barcode: '12421432143214323',
                  price: '7.00',
                  num: '4',
                  amount: '28.00'
                },
                {
                  id: '1234564',
                  name: '特别好吃的蛋卷',
                  barcode: '12421432143214324',
                  price: '8.50',
                  num: '3',
                  amount: '25.50'
                }
              ],
              pageSize: 10,
              pageNo: 1,
              totalPage: 1,
              totalCount: 10
            })
          })).then(res => {
            return res
          })
        },

        loadScheduleData: () => {
          return new Promise((resolve => {
            resolve({
              data: [
                {
                  key: '1',
                  time: '2017-10-01 14:10',
                  rate: '联系客户',
                  status: 'processing',
                  operator: '取货员 ID1234',
                  cost: '5mins'
                },
                {
                  key: '2',
                  time: '2017-10-01 14:05',
                  rate: '取货员出发',
                  status: 'success',
                  operator: '取货员 ID1234',
                  cost: '1h'
                },
                {
                  key: '3',
                  time: '2017-10-01 13:05',
                  rate: '取货员接单',
                  status: 'success',
                  operator: '取货员 ID1234',
                  cost: '5mins'
                },
                {
                  key: '4',
                  time: '2017-10-01 13:00',
                  rate: '申请审批通过',
                  status: 'success',
                  operator: '系统',
                  cost: '1h'
                },
                {
                  key: '5',
                  time: '2017-10-01 12:00',
                  rate: '发起退货申请',
                  status: 'success',
                  operator: '用户',
                  cost: '5mins'
                }
              ],
              pageSize: 10,
              pageNo: 1,
              totalPage: 1,
              totalCount: 10
            })
          })).then(res => {
            return res
          })
        },
      }
    },
    computed: {
      title () {
        return this.$route.meta.title
      },
      goodsColumns () {
        return [
          {
            title: this.$t('商品编号'),
            dataIndex: 'id',
            key: 'id'
          },
          {
            title: this.$t('商品名称'),
            dataIndex: 'name',
            key: 'name'
          },
          {
            title: this.$t('商品条码'),
            dataIndex: 'barcode',
            key: 'barcode'
          },
          {
            title: this.$t('单价'),
            dataIndex: 'price',
            key: 'price',
            align: 'right'
          },
          {
            title: this.$t('数量（件）'),
            dataIndex: 'num',
            key: 'num',
            align: 'right'
          },
          {
            title: this.$t('金额'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'right'
          }
        ]
      },
      scheduleColumns () {
        return [
          {
            title: this.$t('时间'),
            dataIndex: 'time',
            key: 'time'
          },
          {
            title: this.$t('当前进度'),
            dataIndex: 'rate',
            key: 'rate'
          },
          {
            title: this.$t('状态'),
            dataIndex: 'status',
            key: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: this.$t('操作员ID'),
            dataIndex: 'operator',
            key: 'operator'
          },
          {
            title: this.$t('耗时'),
            dataIndex: 'cost',
            key: 'cost'
          }
        ]
      }
    },
    methods: {
      statusText(status) {
        const statusMap = {
          'processing': '进行中',
          'success': '完成',
          'failed': '失败'
        }
        return this.$t(statusMap[status])
      }
    },

  }
</script>

<style lang="less" scoped>
  .title {
    color: rgba(0,0,0,.85);
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 16px;
  }
</style>